export enum PageTab {
  Individual = 'individual',
  Team = 'team',
  Company = 'company'
}
